export const experienceData = [
    {
        id: 1,
        company: 'USAA',
        jobtitle: 'Senior Software Engineer',
        startYear: 'May 2024',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Digital Ellanky',
        jobtitle: 'Software Engineer',
        startYear: 'Jan 2022',
        endYear: 'Aug 2022'
    },
    {
        id: 3,
        company: 'Jiyyo Innovations',
        jobtitle: 'Software Engineer',
        startYear: 'Jul 2021',
        endYear: 'Jan 2022'
    },
    {
        id: 4,
        company: 'Cognizant Technology Solutions',
        jobtitle: 'Software Engineer',
        startYear: 'Dec 2018',
        endYear: 'Jul 2021'
    },
    {
        id: 5,
        company: 'Publicis Sapient',
        jobtitle: 'Software Developer Intern',
        startYear: 'Mar 2018',
        endYear: 'Jul 2018'
    },
]